import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { IoEyeOutline, IoEyeOffOutline, IoClose, IoCheckmarkDoneSharp, IoChevronBack } from "react-icons/io5";
import '../css/signupforms.css';
import PasswordResetRequest from "../modules/PasswordResetRequest";

const USER_REGEX = /^[a-zA-Z][a-zA-Z0-9-_ -]{3,29}$/;
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,30}$/;
const PWD_REGEX = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,30}$/;
const NAAM_REGEX = /^[a-zA-Z-_ -]{1,30}$/;


const Aanmelden = () => {

    const auth = useAuth();
    const navigate = useNavigate();
    

    const redirectPath = '/';

    const initialFormData = {
        gebruikersnaam: "", 
        loginemail: "", 
        password: "",
        confirmPassword: "", 
        voornaam: "", 
        achternaam: "", 
        tussenvoegsel: "",
        info: "" 
    }

    const [formData, setFormData] = useState(initialFormData);
    const [showpassword, setShowPassword] = useState(false);
    const [loginMessage, setLoginMessage] = useState("");
    const [isSignup, setIsSignup] = useState(false);
    const [passwordReset, setPasswordReset] = useState(false);

    const [validGebruikersnaam, setValidGebruikersnaam] = useState(false);
    const [gebruikersnaamFocus, setGebruikersnaamFocus] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [emailFocus, setEmailFocus] = useState(false);
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);
    const [validMatch, setValidMatch] = useState(false);
    const [validVoornaam, setValidVoornaam] = useState(false);
    const [validAchternaam, setValidAchternaam] = useState(false);
    // const [matchFocus, setMatchFocus] = useState(false);




    useEffect(() => {
        const result = USER_REGEX.test(formData.gebruikersnaam);
        setValidGebruikersnaam(result);
    },[formData.gebruikersnaam]);

    useEffect(() => {
        const result = EMAIL_REGEX.test(formData.loginemail);
        setValidEmail(result);
    },[formData.loginemail]);

    useEffect(() => {
        const result = PWD_REGEX.test(formData.password);
        setValidPwd(result);
    },[formData.password]);

    useEffect(() => {
        const result = formData.confirmPassword && formData.password === formData.confirmPassword;
        setValidMatch(result);
    },[formData.password, formData.confirmPassword]);

    useEffect(() => {
        const result = NAAM_REGEX.test(formData.voornaam);
        setValidVoornaam(result);
    },[formData.voornaam]);

    useEffect(() => {
        const result = NAAM_REGEX.test(formData.achternaam);
        setValidAchternaam(result);
    },[formData.achternaam]);






    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async(e) => {
        e.preventDefault();
        setLoginMessage("");
        if (isSignup) {
            if(formData.password === formData.confirmPassword) {
                const data = {
                    method: 'POST',
                    path: 'auth/register',
                    input: {
                        gebruikersnaam: formData.gebruikersnaam, 
                        loginemail: formData.loginemail, 
                        password: formData.password,
                        voornaam: formData.voornaam, 
                        achternaam: formData.achternaam, 
                        tussenvoegsel: formData.tussenvoegsel,
                        info: formData.info 
                    }
                }
                const result = await auth.create(data);
                if (result.success) {
                    setLoginMessage("Je account is aangemaakt. Binnen een paar seconden wordt je doogestuurd naar je dashboard in deze app.")
                    waitForwarding()

                } else {
                    setLoginMessage("Er is iets misgegaan bij het aanmaken van je account. Probeer het nogeens of neem contact op.")
                }

            } else {
                setLoginMessage("Beide wachtwoorden zijn niet gelijk");
            }
        } else {
            setLoginMessage("Je login data wordt verwerkt. Dit kan soms een paar seconden duren.");
            const data = {
                method: 'POST',
                path: 'auth/login',
                input: {
                    loginemail: formData.loginemail,
                    password: formData.password
                }
            }
            const result = await auth.login(data);
            if (result.success) {
                setLoginMessage('');
                navigate(redirectPath, { replace: true });
            } else {
                result.message && setLoginMessage(result.message);
            }
            
        } 
    }

    const waitForwarding = () => {
        setTimeout(navigate, 3000, redirectPath, { replace: true});
    }

    const toggleShowPassword = () => {
        setShowPassword((prevShowpassword) => !prevShowpassword);
    }


    const handleClickToggleLogin = (e) => {
        e.preventDefault();
        setIsSignup(!isSignup);
        setFormData(initialFormData);
        setShowPassword(false);
    }

    const handleClose = (e) => {
        e.preventDefault();
        navigate(redirectPath, { replace: true });
    }

    const handlePassReset = (e) => {
        e.preventDefault();
        setPasswordReset(true);
    }




    return (
        <>
            <div className="authContainer">
                {!passwordReset &&
                <form onSubmit={handleSubmit}>
                    <div className="aanmeldContainer">
                        {isSignup && (
                            <div className="signupInfo">
                                <p className="aanmeldInfoTitle">Privacy info over het aanmelden:</p>
                                <p className="aanmeldInfo">
                                    Je gebruikersnaam is zichtbaar voor andere gebruikers van de app. Je volledige naam en email zijn alleen zichtbaar voor bestuur / activiteitencommissie / contactpersonen.
                                </p>
                            </div>
                        
                        )}
                        <div className="aanmeldInputContainer">
                            <div className="aanmeldBody">
                                <div className="aanmeldTop">
                                    <h2>{isSignup ? "Account aanmaken" : "Inloggen"}</h2>
                                    <button onClick={handleClose}>{<IoClose />}</button>
                                </div>

                            {isSignup && (

                                <div className="inputBox">
                                    <label htmlFor="gebruikersnaam">
                                        Gebruikersnaam:
                                        {
                                            validGebruikersnaam && 
                                            <span className="checkmark">
                                                <IoCheckmarkDoneSharp />
                                            </span>
                                        }
                                        {
                                            !validGebruikersnaam &&
                                            <span className="notValid">
                                                <IoChevronBack />
                                            </span>
                                        }
                                    </label>
                                    <input 
                                        name ="gebruikersnaam" 
                                        id="gebruikersnaam" 
                                        type="text"
                                        // ref={gebruikersnaamRef} 
                                        autoComplete="off"
                                        onChange={handleChange} 
                                        value={formData.gebruikersnaam}
                                        required 
                                        autoFocus
                                        onFocus={() => setGebruikersnaamFocus(true)}
                                        onBlur={() => setGebruikersnaamFocus(false)}
                                        
                                        maxLength="30"
                                     />
                                     {
                                        (isSignup && gebruikersnaamFocus && !validGebruikersnaam) &&
                                        <p className="inputInfo">
                                            Minimaal 4, maximaal 30 karakters. <br />
                                            Alleen letters, cijfers, spatie en streepje. <br />
                                            Beginnend met een letter. <br />


                                        </p>    
                                     }
                                     
                                </div>

                            )}
                                <div className="inputBox">
                                    <label htmlFor="loginemail">
                                        Loginemail: 
                                        {
                                            (isSignup && validEmail) && 
                                            <span className="checkmark">
                                                <IoCheckmarkDoneSharp />
                                            </span>
                                        }
                                        {
                                            (isSignup && !validEmail) &&
                                            <span className="notValid">
                                                <IoChevronBack />
                                            </span>
                                        }

                                    </label>
                                    <input 
                                        name="loginemail" 
                                        id="loginemail" 
                                        type="email" 
                                        // ref={emailRef}
                                        // autoComplete="off"
                                        onChange={handleChange} 
                                        value={formData.loginemail} 
                                        required
                                        onFocus={() => setEmailFocus(true)}
                                        onBlur={() => setEmailFocus(false)}
                                    />
                                    {
                                        (emailFocus && !validEmail) &&
                                        <p className="inputInfo">
                                            Vul een geldig emailadres in. <br />


                                        </p>    
                                    }

                                </div>
                                <div className="inputBox">
                                    <label htmlFor="password">
                                        Wachtwoord: 
                                        {
                                            (isSignup && validPwd) && 
                                            <span className="checkmark">
                                                <IoCheckmarkDoneSharp />
                                            </span>
                                        }
                                        {
                                            (isSignup && !validPwd) &&
                                            <span className="notValid">
                                                <IoChevronBack />
                                            </span>
                                        }

                                    </label>
                                    <div className="passwordContainer">
                                        <input 
                                            name="password" 
                                            id="password" 
                                            type={showpassword ? "text" : "password"} 
                                            // autoComplete="off"
                                            onChange={handleChange} 
                                            value={formData.password} 
                                            required
                                            onFocus={() => setPwdFocus(true)}
                                            onBlur={() => setPwdFocus(false)}
    
                                        />
                                        <span onClick={toggleShowPassword}>{showpassword ?<IoEyeOutline /> : <IoEyeOffOutline />}</span>

                                    </div>
                                    {
                                        (isSignup && pwdFocus && !validPwd) &&
                                        <p className="inputInfo">
                                            Minimaal 8 karakters. <br />
                                            Ten minste 1 letter, 1 getal en 1 speciaal karakter. <br />
                                        </p>    
                                    }

                                </div>
                            {isSignup && (
                                <>
                                    <div className="inputBox passwordSection">
                                        <label htmlFor="confirmPassword">
                                            Herhaal wachtwoord: 
                                            {
                                            (isSignup && validMatch) && 
                                            <span className="checkmark">
                                                <IoCheckmarkDoneSharp />
                                            </span>
                                        }
                                        {
                                            (isSignup && !validMatch && formData.password) &&
                                            <span className="notValid">
                                                <IoChevronBack />
                                            </span>
                                        }

                                        </label>
                                        <div className="passwordContainer">
                                            <input 
                                                name="confirmPassword" id="confirmPassword" 
                                                type={showpassword ? "text" : "password"} 
                                                autoComplete="off"
                                                onChange={handleChange} 
                                                value={formData.confirmPassword} 
                                                required
                                                // onFocus={() => setMatchFocus(true)}
                                                // onBlur={() => setMatchFocus(false)}
    
                                            />
                                            <span onClick={toggleShowPassword}>{showpassword ?<IoEyeOutline /> : <IoEyeOffOutline />}</span>

                                        </div>
                                        {/* {
                                        (matchFocus && !validMatch) &&
                                        <p className="inputInfo">
                                            Herhaal wachtwoord. <br />
                                        </p>    
                                        } */}

                                    </div>



                                    <div className="inputBox">
                                        <label htmlFor="voornaam">
                                            Voornaam: 
                                            {
                                                validVoornaam && 
                                                <span className="checkmark">
                                                    <IoCheckmarkDoneSharp />
                                                </span>
                                            }
                                            {
                                                !validVoornaam &&
                                                <span className="notValid">
                                                    <IoChevronBack />
                                                </span>
                                            }

                                        </label>
                                        <input 
                                            name="voornaam" 
                                            id="voornaam" 
                                            type="text" 
                                            onChange={handleChange} 
                                            value={formData.voornaam} 
                                            required />
                                        
                                        <div className="achternaamContainer">
                                            <div className="inputBox" >
                                                <label htmlFor="achternaam">
                                                    Achternaam: 
                                                    {
                                                        validAchternaam && 
                                                        <span className="checkmark">
                                                            <IoCheckmarkDoneSharp />
                                                        </span>
                                                    }
                                                    {
                                                        !validAchternaam &&
                                                        <span className="notValid">
                                                            <IoChevronBack />
                                                        </span>
                                                    }

                                                </label>

                                                <input 
                                                    name="achternaam" 
                                                    id="achternaam" 
                                                    type="text" 
                                                    onChange={handleChange} 
                                                    value={formData.achternaam} 
                                                    required/>
                                            </div>
                                            <div className="inputBox">
                                                <label htmlFor="tussenvoegsel">Tussenvoegsel</label>
                                                <input 
                                                    name="tussenvoegsel" 
                                                    id="tussenvoegsel" 
                                                    type="text" 
                                                    onChange={handleChange} 
                                                    value={formData.tussenvoegsel} />

                                            </div>

                                        </div>

                                    </div>
                                    <div className="inputBox infoInput">
                                        <label htmlFor="info">Info</label>
                                        <textarea 
                                            name="info" 
                                            id="info" 
                                            onChange={handleChange} 
                                            value={formData.info} 
                                            cols="50" 
                                            rows="5"
                                            placeholder="Voeg hier eventueel extra info toe, bijvoorbeeld als je een account start als ouder/verzorger van een minderjarig lid."
                                        ></textarea>

                                    </div>

                                </>
                            )}


                                <button 
                                    className={`submitLogin ${(isSignup && (!validGebruikersnaam || !validEmail || !validPwd || !validMatch || ! validVoornaam || !validAchternaam)) ? "invalid" : "valid" }`}
                                    
                                    disabled={isSignup && (!validGebruikersnaam || !validEmail || !validPwd || !validMatch || ! validVoornaam || !validAchternaam)}
                                >
                                    {isSignup ? "Account aanmaken" : "Inloggen"}
                                </button>

                                <button className=" passResetButton button small" onClick={handlePassReset}>Wachtwoord resetten</button>

                            </div>
                        </div>
                        {
                            loginMessage &&
                            <div className="loginmessage">
                                <p>{loginMessage}</p>
                            </div>

                        }

                        <button 
                            className="toggleLogin"
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={handleClickToggleLogin}>{isSignup ? "Heb je al een account? Klik hier om in te loggen" : "Nog geen account? Klik hier om je account aan te maken"}</button>


                    </div>
                </form>
                }
                {passwordReset && <PasswordResetRequest />}

            </div>
        </>
    );
}

export default Aanmelden;